export default "__VITE_ASSET__CwJ1dimP__"